__turbopack_context__.v({
  "agentInfoContainer": "_215rCG_agentInfoContainer",
  "agentName": "_215rCG_agentName",
  "agentTitle": "_215rCG_agentTitle",
  "banner": "_215rCG_banner",
  "bannerContainer": "_215rCG_bannerContainer",
  "bannerImage": "_215rCG_bannerImage",
  "companyTitle": "_215rCG_companyTitle",
  "profilePhoto": "_215rCG_profilePhoto",
  "profilePhotoContainer": "_215rCG_profilePhotoContainer",
});
